import axios from "axios";

export default axios.create({
    baseURL:'https://chintamanibacked.azurewebsites.net/stocks/'
})